import { BASE_MARGIN } from "$components/DesignSystem"
import React, { useEffect } from "react"
import { View } from "react-native"

import { useIsMobile } from "../../hooks/useIsMobile"
import { LoginError } from "../svgAnimations/LoginError"
import { LoginStartLogin } from "../svgAnimations/LoginStartLogin"
import { LoginStartSignup } from "../svgAnimations/LoginStartSignup"
import { LoginTypingPrivate } from "../svgAnimations/LoginTypingPrivate"
import { LoginTypingPublic } from "../svgAnimations/LoginTypingPublic"
import { LoginWaiting } from "../svgAnimations/LoginWaiting"

const SVG_WIDTH = 240
type phases = "start" | "typing-public" | "typing-private" | "waiting-private" | "waiting-public" | "error"

export function ModalMascot(props: { screen: "login" | "signup"; hasError?: boolean; publicText: string; privateText: string }) {
  const { publicText, privateText, hasError } = props
  const [phase, setPhase] = React.useState<phases>("start")
  const mobile = useIsMobile()
  const typingTimeout = React.useRef<NodeJS.Timeout>()

  const lastTextType = React.useRef<"public" | "private">("public")
  const lastPublicText = React.useRef(publicText)
  const isNewPublicText = lastPublicText.current !== publicText
  if (isNewPublicText) {
    setPhase("typing-public")
    lastTextType.current = "public"
    lastPublicText.current = publicText
  }

  const lastPrivateText = React.useRef(privateText)
  const isNewPrivateText = lastPrivateText.current !== privateText
  if (isNewPrivateText) {
    setPhase("typing-private")
    lastTextType.current = "private"
    lastPrivateText.current = privateText
  }

  const hadError = React.useRef(hasError)
  if (hadError.current !== hasError) {
    if (hasError) {
      setPhase("error")
    }
    hadError.current = hasError
  }

  useEffect(() => {
    if (phase === "error" || phase === "typing-public" || phase === "typing-private") {
      typingTimeout.current = setTimeout(
        () => {
          setPhase(`waiting-${lastTextType.current}`)
        },
        phase === "error" ? 600 : 1000
      )
    }

    return () => {
      if (typingTimeout.current) {
        clearTimeout(typingTimeout.current)
      }
    }
  }, [phase, hasError, publicText, privateText])

  useEffect(() => {
    setTimeout(() => {
      setPhase("waiting-public")
    }, 1100)
  }, [])

  return (
    <View
      pointerEvents="none"
      style={{
        flex: 4,
        marginLeft: mobile ? 0 : BASE_MARGIN,
        marginTop: -BASE_MARGIN * 3,
        marginBottom: mobile ? -BASE_MARGIN * 2.5 : 0,
        display: "flex",
        maxHeight: mobile ? 180 : undefined,
        alignItems: mobile ? "center" : "flex-start",
      }}
    >
      {phase === "typing-public" && <LoginTypingPublic width={SVG_WIDTH} />}
      {phase === "typing-private" && <LoginTypingPrivate width={SVG_WIDTH} />}
      {phase === "start" && props.screen === "signup" && <LoginStartSignup width={SVG_WIDTH} />}
      {phase === "start" && props.screen === "login" && <LoginStartLogin width={SVG_WIDTH} />}
      {phase === "waiting-public" && <LoginWaiting width={SVG_WIDTH} />}
      {phase === "waiting-private" && <LoginWaiting width={SVG_WIDTH} />}
      {phase === "error" && <LoginError width={SVG_WIDTH} />}
    </View>
  )
}
